<template>
  <div class="">
    <cooperators-create> </cooperators-create>
  </div>
</template>

<script>
import CooperatorsCreate from "@/components/profile/cooperators/create.vue";
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
  },
  components: {
    CooperatorsCreate,
  },
  created() {
    this.notifyQueue({
      text: "Crea Collaborazione Orizzontale",
      path: "brokers.create1",
      level: 3,
    });
  },
};
</script>
